import classNames from 'classnames';
import { Dropdown } from 'primereact/dropdown';
import { useContext } from 'react';
import { DynamicFormFieldProps } from '../../types/types';
import { OPTION_LABEL_KEY, OPTION_VALUE_KEY } from '../../../constants/dynamic-form-config';
import { getDynamicFieldTooltip } from '../../../utils/helper';
import { AttributeConfigContext } from '../../../utils/AttributeConfigProvider';
import { isAttributeDisabled } from '../../../utils/attribute';

type Props = DynamicFormFieldProps;

export default function DropdownInput({
  attribute,
  field,
  fieldState,
  watch,
}: Props) {
  const { getFilteredOptions } = useContext(AttributeConfigContext);

  const options = watch ? getFilteredOptions(attribute, watch) : attribute.options;
  return (
    <Dropdown
      className={classNames({ 'w-full': true, 'p-error': fieldState.error })}
      options={options}
      optionLabel={OPTION_LABEL_KEY}
      optionValue={OPTION_VALUE_KEY}
      value={field.value}
      filter
      onChange={(e) => field.onChange(e.value)}
      disabled={isAttributeDisabled(attribute) || options.length === 0}
      {...getDynamicFieldTooltip(attribute)}
    />
  );
}
